// Styles
import { loadMinicart, openMinicart } from '../../scripts/components/minicart';
import { headerHeight } from '../../scripts/helpers';
import './template-product.scss';
import {
  createOmnibusEndpoint,
  getOmnibusPriceFromAPI,
  renderOmnibusPriceFromAPI,
} from '../../scripts/components/omnibus';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest('.shopify-section');
  if (!templateProductSection) return;

  const initProductGallery = (gallery) => {
    if (gallery.classList.contains('product-gallery--thumbnails')) {
      const swiperGallery = new Swiper(
        gallery.querySelector('.product-gallery__container'),
      );
      gallery
        .querySelectorAll('.product-gallery__grid-thumbnail')
        .forEach((thumbnail) => {
          const thumbnailIndex = thumbnail.dataset.thumbnailIndex;
          thumbnail.addEventListener('click', () => {
            document.querySelectorAll('.product-gallery__grid-thumbnail').forEach((el) => {
              el.classList.remove('active');
            });
            thumbnail.classList.add('active');
            swiperGallery.slideTo(thumbnailIndex);
          });
        });
    } else if (gallery.classList.contains('product-gallery--scroll')) {
      const thumbnailsContainer = gallery.querySelector('.swiper-wrapper');
      const slideHeight = gallery.querySelector('.swiper-slide').clientHeight;
      gallery
        .querySelectorAll('.product-gallery__scroll-thumbnail')
        .forEach((thumbnail) => {
          const thumbnailIndex = parseInt(thumbnail.dataset.thumbnailIndex);
          thumbnail.addEventListener('click', () => {
            thumbnailsContainer.scrollTop = slideHeight * thumbnailIndex;
          });
        });
    }
  };

  const productsGalleries =
    templateProductSection.querySelectorAll('.product-gallery');

  productsGalleries.forEach((productsGallery) => {
    if (templateProductSection.classList.contains('maxheight')) {
      productsGallery.style.maxHeight = `calc(100vh - ${headerHeight()}px)`;
    }
    ['resize', 'orientationchange'].forEach((evt) => {
      window.addEventListener(evt, () => {
        if (templateProductSection.classList.contains('maxheight')) {
          productsGallery.style.maxHeight = `calc(100vh - ${headerHeight()}px)`;
        }
      });
    });

    let direction = productsGallery.dataset.pagination == 'bottom' ? 'horizontal' : 'vertical';
    if (productsGallery.classList.contains('product-gallery--carousel')) {
      direction = 'horizontal';
    }

    new Swiper(productsGallery.querySelector('.product-gallery__container'), {
      loop: productsGallery.classList.contains('product-gallery--scroll')
        ? false
        : true,
      direction: direction,
      pagination: {
        el: productsGallery.querySelector('.product-gallery__pagination'),
        type: productsGallery.dataset.paginationType,
        clickable: true,
        renderCustom: function (swiper, current, total) {
          return `<span>${current} ${productsGallery.dataset.paginationSeparator} ${total}</span>`;
        },
      },
      navigation: {
        prevEl: productsGallery.querySelector('.product-gallery__arrow--left'),
        nextEl: productsGallery.querySelector('.product-gallery__arrow--right'),
      },
      breakpoints: {
        1025: {
          allowSlidePrev: productsGallery.classList.contains(
              'product-gallery--scroll',
          )
            ? false
            : true,
          allowSlideNext: productsGallery.classList.contains(
              'product-gallery--scroll',
          )
            ? false
            : true,
        },
      },
    });

    initProductGallery(productsGallery);
  });

  const swatchesSlider =
    templateProductSection.querySelector('.swatches-slider');

  if (swatchesSlider) {
    new Swiper(swatchesSlider, {
      slidesPerView: 7,
      spaceBetween: 8,
      navigation: {
        prevEl: swatchesSlider.querySelector('.swatches-slider__arrow--left'),
        nextEl: swatchesSlider.querySelector('.swatches-slider__arrow--right'),
      },
      breakpoints: {
        767: {
          slidesPerView: 14,
        },
        1025: {
          slidesPerView: 9,
        },
        2000: {
          slidesPerView: 14,
        },
      },
    });
  }

  const productForm = templateProductSection.querySelector('.product__form');
  setTimeout(() => {
    if (
      typeof ShopifyAPI !== 'undefined' &&
      typeof ShopifyAPI.addItemFromForm !== 'undefined'
    ) {
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();
        ShopifyAPI.addItemFromForm(
          productForm,
          async () => {
              await loadMinicart();
              openMinicart();
            },
            (XMLHttpRequest, textStatus) => {
              const errorWrapper = productForm.querySelector(
                '.product__form__error',
              );
              if (errorWrapper && XMLHttpRequest?.responseJSON?.description) {
                errorWrapper.innerText = XMLHttpRequest.responseJSON.description;
                setTimeout(() => {
                  errorWrapper.innerText = '';
                }, 5000);
              }
            },
        );
      });
    }
  }, "200");
  productForm
    .querySelectorAll('.product__form__option__toggle')
    .forEach((toggle) => {
      const fieldset = toggle.closest('.swatches-container');
      if (!fieldset) return;
      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('checked')) return;
        const checkedLabels = fieldset.querySelectorAll('label[checked]');
        checkedLabels.forEach((label) => {
          label.removeAttribute('checked');
        });
        toggle.setAttribute('checked', '');
      });
    });

  const colorsAccordion = productForm.querySelector(
    '.product__form__colors-accordion',
  );
  if (colorsAccordion) {
    const accordionHeader = colorsAccordion.querySelector(
      '.product__form__colors-accordion__header',
    );
    const accordionContent = colorsAccordion.querySelector(
      '.product__form__colors-accordion__content',
    );
    if (accordionHeader && accordionContent) {
      var isMoving = false;
      accordionHeader.addEventListener('click', function () {
        if (isMoving) return;
        isMoving = true;
        if (colorsAccordion.getAttribute('open')) {
          $(accordionContent).slideUp(350, function () {
            isMoving = false;
            colorsAccordion.removeAttribute('open');
            this.style.display = '';
          });
        } else {
          $(accordionContent).slideDown(350, function () {
            isMoving = false;
            colorsAccordion.setAttribute('open', 'true');
            this.style.display = '';
          });
        }
      });

      const colorToggles = accordionContent.querySelectorAll('.color-label');
      if (colorToggles.length > 0) {
        colorToggles.forEach((toggle) => {
          const colorValue = toggle.closest('.color-label').dataset.colorValue;
          const summaryColor = accordionHeader.querySelector('.color-label');
          if (colorValue && summaryColor) {
            toggle.addEventListener('click', () => {
              summaryColor.innerText = colorValue;
              summaryColor.dataset.colorValue = colorValue;
            });
          }
        });
      }
    }
  }

  const handleQtyButtons = () => {
    const qtySelectorInput = document.querySelector('.js-qty .js-qty__num');
    const qtySelectorBtnMinus = document.querySelector(
      '.js-qty .js-qty__adjust--minus',
    );
    const qtySelectorBtnPlus = document.querySelector(
      '.js-qty .js-qty__adjust--plus',
    );
    if (
      !qtySelectorInput ||
      !qtySelectorBtnMinus ||
      !qtySelectorBtnPlus ||
      !qtySelectorInput.dataset.stock
    )
      return;

    if (
      parseInt(qtySelectorInput.value) >=
      parseInt(qtySelectorInput.dataset.stock)
    ) {
      qtySelectorInput.value = qtySelectorInput.dataset.stock;
      qtySelectorBtnPlus.setAttribute('disabled', '');
    } else {
      qtySelectorBtnPlus.removeAttribute('disabled');
    }

    if (parseInt(qtySelectorInput.value) <= 1) {
      qtySelectorBtnMinus.setAttribute('disabled', '');
    } else {
      qtySelectorBtnMinus.removeAttribute('disabled');
    }
  };

  const selectedOption = productForm.querySelector(
    `select[name="id"] option[selected][data-stock]`,
  );
  const qtySelectorInput = document.querySelector('.js-qty .js-qty__num');
  const qtySelectorBtnMinus = document.querySelector(
    '.js-qty .js-qty__adjust--minus',
  );
  const qtySelectorBtnPlus = document.querySelector(
    '.js-qty .js-qty__adjust--plus',
  );
  if (qtySelectorInput && qtySelectorBtnMinus && qtySelectorBtnPlus) {
    var qtyValue = 1;

    if (selectedOption) {
      var qtyValueRounded = Math.floor(selectedOption.dataset.stock / selectedOption.dataset.multiplier);
      if (qtyValueRounded >= 1) {
        qtyValue = qtyValueRounded;
      }
    }

    qtySelectorInput.setAttribute('data-stock', qtyValue);

    [qtySelectorBtnMinus, qtySelectorBtnPlus].forEach((el) => {
      el.addEventListener('click', () => {
        handleQtyButtons();
      });
    });

    handleQtyButtons();
  }

  const renderOmnibusPrice = async function (
    container,
    vId = false,
    vPrice = false,
    vHasPromo = false,
  ) {
    const variantID = vId || container.getAttribute('data-omnibus_id');
    const variantPrice = vPrice || container.getAttribute('data-variant_price');
    const brand = container.getAttribute('data-omnibus_brand');
    const hasPromo = vHasPromo || container.getAttribute('data-has_promo');

    renderOmnibusPriceFromAPI(
      container,
      await getOmnibusPriceFromAPI(brand, variantID),
      variantPrice,
      hasPromo,
    );
  };

  const getOBContainers = function () {
    const omnibusContainers = document.querySelectorAll(
      '[data-omnibus_price-container]',
    );
    const OBContainersByEndpoint = {};

    if (omnibusContainers && omnibusContainers.length) {
      const OBContainers = Array.prototype.slice.call(omnibusContainers);

      OBContainers.map((container) => {
        const currentID = container.getAttribute('data-omnibus_id');
        const currentBrand = container.getAttribute('data-omnibus_brand');
        const currentEndpoint = createOmnibusEndpoint(currentBrand, currentID);

        if (!OBContainersByEndpoint[currentEndpoint])
          OBContainersByEndpoint[currentEndpoint] = [];
        OBContainersByEndpoint[currentEndpoint].push(container);
      });
    }

    return OBContainersByEndpoint;
  };

  const OBContainersByEndpoint = getOBContainers();
  for (const [endpoint, containers] of Object.entries(OBContainersByEndpoint)) {
    for (let i = 0; i < containers.length; ++i) {
      renderOmnibusPrice(containers[i]);
    }
  }

  $(context).on('variantChange', (e) => {
    if (!e || !e.variant) return;

    const OBContainersByEndpoint = getOBContainers();

    for (const [endpoint, containers] of Object.entries(
      OBContainersByEndpoint,
    )) {
      for (let i = 0; i < containers.length; ++i) {
        renderOmnibusPrice(containers[i], e.variant.id, e.variant.price);
      }
    }

    const selectedOption = productForm.querySelector(
      `select[name="id"] option[value="${e.variant.id}"][data-stock]`,
    );
    if (!selectedOption) return;

    if (qtySelectorInput) {
      var qtyValue = 1;

      if (selectedOption) {
        var qtyValueRounded = Math.floor(selectedOption.dataset.stock / selectedOption.dataset.multiplier);
        if (qtyValueRounded >= 1) {
          qtyValue = qtyValueRounded;
        }
      }
      qtySelectorInput.setAttribute('data-stock', qtyValue);
    }

    handleQtyButtons();
  });

  $('.product-template').on('variantSKUChange', function (e) {

    const active = this.querySelector('.product-gallery[active]');
    if (active) {
      active.removeAttribute('active');
    }

    const noShoppable = this.querySelector('.product__meta.no-shoppable');

    const currentSku = this.querySelector('.product-single .product__meta__code');
    currentSku.innerText = e.variant.sku;

    const currentBarcode = this.querySelector('.product__form__option__title__sku .product__form__option__title--value');
    currentBarcode.innerText = e.variant.barcode;

    const currentValues = this.querySelectorAll('.product__form__option__title__variant:not(.product__form__option__title__variant--temperature) .product__form__option__title--value');
    currentValues?.forEach((currentValue, index) => currentValue.innerText = e.variant.options[index]);

    const currentMultiplier = this.querySelector('.product__form input[name="multiplier"]');
    const selectedMultiplier = this.querySelector('.product__form__option__toggle[checked]').getAttribute('data-multiplier');
    currentMultiplier.value = selectedMultiplier;

    const addToCartButtons = this.querySelectorAll('.btn__add-to-cart[data-btn-add-to-cart]');
    const productFormButton = this.querySelector('.product__form__bottom');

    if (e.variant.available == true || noShoppable) {
      productFormButton.style.display = 'flex';
      addToCartButtons?.forEach((addToCartButton) => addToCartButton.style.display = 'block');
    } else {
      productFormButton.style.display = 'none';
      addToCartButtons?.forEach((addToCartButton) => addToCartButton.style.display = 'none');
    }

    const galleries = this.querySelectorAll('.product-gallery');
    for (let i = 0; i < galleries.length; i++) {
      const gallery = galleries[i];
      if (gallery.getAttribute('data-sku') == e.variant.sku) {
        gallery.setAttribute('active', true);
        initProductGallery(gallery);
      }
    }

    const features = this.querySelectorAll('.product__meta__accordions details[data-index="pdp-desktop-accordion-features"] .accordion-content');
    const currentFeatures = this.querySelector('.product__meta__accordions details[data-index="pdp-desktop-accordion-features"] .accordion-content[data-variant-sku="' + e.variant.sku + '"]')

    features?.forEach((feature) => feature.classList.add('hidden'));
    currentFeatures?.classList.remove('hidden');

    const downloads = this.querySelectorAll('.product__meta__accordions details[data-index="pdp-desktop-accordion-downloads"] .accordion-content');
    const currentDownloads = this.querySelector('.product__meta__accordions details[data-index="pdp-desktop-accordion-downloads"] .accordion-content[data-variant-sku="' + e.variant.sku + '"]')

    downloads?.forEach((feature) => feature.classList.add('hidden'));
    currentDownloads?.classList.remove('hidden');
  });

  // MANAGE LIGHT TEMPERATURE CHANGE

  const temperatureOptions = document.querySelector('.product__form__option--temperature');

  if (temperatureOptions) {
    temperatureOptions.querySelectorAll('.option-box input')?.forEach((option) => {
      $(option).on('change', function () {
        temperatureOptions.querySelector('.product__form__option__title--value').innerText = option.value;
      });
    });
  }
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
